import React, {useEffect, useState} from "react";
import { CONFIG } from "../../utils/config";
import "./Footer.css";
import {FooterLink} from "../../utils/UtilsFunc";
import {useLocation, useNavigate} from "react-router-dom";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";


const Footer: React.FC = () => {
  
  const navigate = useNavigate();
  const loaction = useLocation();
  const adminPathChk = loaction?.pathname?.startsWith('/admin');
  const {
    isEmbed,
    isAuthenticated,
    hasAdminPermission,
    hasManagerPermission,
    hasSystemPermission
  } = useMembership();

  const onHandleLink = async (link:string) => {
    console.log(`링크`)
    navigate(link);
    window.location.reload();
  }
  
  const onSnsLink = (link:any) => {
    window.open(link,'_blank');
  }
  const onNav = (link:any,type:any) => {
    if(type === 'order') {
      if(!isAuthenticated) {
        alert('회원만 멤버십 결제 가능합니다.')
        return;
      }
      navigate(link);
      window.location.reload();
    }
    if(type === 'url') {
      window.open(link,`_blank`);
    }
  }
  
  const fixedFooterChk = (pathname:string) => {
    let res = ``;
    if(pathname === `/order`) {
      res = `order_footer`;
    }
    if(pathname === `/order/payment`) {
      res = `payment_footer`;
    }
    return res;
  }
  
  console.warn(adminPathChk)
  
  return (
    <>
    {isEmbed() || adminPathChk ? (<></>) : (
    <footer className={`footer ${fixedFooterChk(loaction?.pathname)}`}>
      <div className={`sec sec_1 flex flex-wrap items-start justify-between`}>
        <div className={`sec_left`}>
          <h3 className={`tit h3`}>기억의 서랍</h3>
          <p className={`txt caption`}>평범한 일상이 특별한 이야기로</p>
          <nav className={`sns_links`}>
            <button onClick={()=>onSnsLink(`https://www.instagram.com/memory.drawer25`)} className={`link_btn i_instar`}></button>
            <button onClick={()=>onSnsLink(`https://age-tech.tistory.com`)} className={`link_btn t_story`}></button>
            {/*<button onClick={()=>onSnsLink(``)} className={`link_btn i_x`}></button>*/}
          </nav>
        </div>
        <div className={`sec_right flex flex-wrap`}>
          <nav className={`link_nav`}>
            <p className={`tit body1_sb`}>서비스 이용</p>
            <ul>
              {FooterLink?.service?.map((_obj,_idx)=>{
                return (
                  <li key={_idx}>
                    <button onClick={()=>onNav(_obj?.link,_obj?.type)} className={`navi_btn body2`}>{_obj?.name}</button>
                  </li>
                )
              })}
            </ul>
            {/*반복문 구간*/}
          </nav>
          <nav className={`link_nav`}>
            <p className={`tit body1_sb`}>고객센터</p>
            {/*반복문 구간*/}
            <ul>
              {FooterLink?.cscenter?.map((_obj, _idx) => {
                return (
                  <li key={_idx}>
                    <button onClick={()=>navigate(_obj?.link)} className={`navi_btn body2`}>{_obj?.name}</button>
                  </li>
                )
              })}
            </ul>
          </nav>
          <nav className={`link_nav`}>
            <p className={`tit body1_sb`}>이용 약관</p>
            {/*반복문 구간*/}
            <ul>
              {FooterLink?.policy?.map((_obj, _idx) => {
                return (
                  <li key={_idx}>
                    <button onClick={()=>onHandleLink(_obj?.link)} className={`navi_btn body2`}>{_obj?.name}</button>
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </div>
      <div className={`sec sec_2`}>
        <div className={`company_info`}>
          <p className={`caption`}>㈜유탑소프트 | 사업자등록번호: 124-86-68144 | 통신 판매업 신고 번호: 2023-서울강남-04974 | 대표자: 김성범</p>
          <p className={`caption`}>전화 문의: 02-2135-3096 | 주소: 서울특별시 강남구 남부순환로 2621, 12층 1232호(도곡동, 디앤오강남빌딩)</p>
        </div>
      </div>
    </footer>
    )}
    </>
  );
};

export default Footer;
